import axios from 'axios'
import he from 'he'

const YOTPO_APP_KEY = process.env.GATSBY_YOTPO_APP_KEY

const YOTPO_BASE_URL = 'https://api.yotpo.com'

// Reports successful orders to Yotpo for post-order review requests.
export const createYotpoOrder = async (body) =>
  await axios
    .post(`/.netlify/functions/yotpo-create-order`, body)
    .catch((error) => {
      console.error(error, {
        source: 'yotpo.client.createYotpoOrder',
      })
    })

// Gets the review averages/totals for all products.
export const getYotpoProductsBottomLines = async () =>
  await axios
    .get(`${YOTPO_BASE_URL}/v1/apps/${YOTPO_APP_KEY}/bottom_lines/`, {
      params: {
        count: 100,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        return response.data.response.bottomlines
      } else {
        throw new Error(response.statusText)
      }
    })
    .catch((error) => {
      console.error(error, {
        source: 'yotpo.client.getYotpoProductsBottomLines',
      })
    })

// Gets the review averages/totals for the site.
export const getYotpoSiteBottomLine = async () =>
  await axios
    .get(
      `${YOTPO_BASE_URL}/products/${YOTPO_APP_KEY}/yotpo_site_reviews/bottomline/`
    )
    .then((response) => {
      if (response.status === 200) {
        return response.data.response.bottomline
      } else {
        throw new Error(response.statusText)
      }
    })
    .catch((error) => {
      console.error(error, {
        source: 'yotpo.client.getYotpoSiteBottomLine',
      })
    })

// Gets all reviews for the site and products.
export const getYotpoAllReviews = async () =>
  await axios
    // @see https://apidocs.yotpo.com/reference/retrieve-reviews-for-a-product
    .get(`${YOTPO_BASE_URL}/v1/widget/${YOTPO_APP_KEY}/reviews.json`, {
      params: {
        per_page: 150,
        include_site_reviews: 'true',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        return {
          bottomline: {
            count: response.data.response.bottomline.total_review,
            score: response.data.response.bottomline.average_score,
          },
          reviews: transformReviews(
            response.data.response.reviews,
            response.data.response.products
          ),
        }
      } else {
        throw new Error(response.statusText)
      }
    })
    .catch((error) => {
      console.error(error, {
        source: 'yotpo.server.getYotpoAllReviews',
      })
    })

// Gets all reviews for a single products.
export const getYotpoProductReviews = async (id) =>
  await axios
    // @see https://apidocs.yotpo.com/reference/retrieve-reviews-for-a-product
    .get(
      `${YOTPO_BASE_URL}/v1/widget/${YOTPO_APP_KEY}/products/${id}/reviews.json`,
      {
        params: {
          per_page: 150,
        },
      }
    )
    .then((response) => {
      if (response.status === 200) {
        return {
          reviews: transformReviews(
            response.data.response.reviews,
            response.data.response.products
          ),
        }
      } else {
        throw new Error(response.statusText)
      }
    })
    .catch((error) => {
      console.error(error, {
        source: 'yotpo.server.getYotpoProductReviews',
      })
    })

const transformReviews = (reviews, products) =>
  reviews.map((review) => ({
    author: review.user?.display_name,
    body: he.decode(review.content),
    date: review.created_at,
    id: review.id,
    productSlug: products.find(({ id }) => id === review.product_id)
      ?.domain_key,
    score: review.score,
    title: he.decode(review.title),
    verified: review.verified_buyer,
  }))
